import { useTranslation } from "react-i18next"
// icons
import { FaRegUser } from "react-icons/fa"
import { HiOutlineDevicePhoneMobile } from "react-icons/hi2"
import { HiOutlineMail } from "react-icons/hi"
import { BiStats } from "react-icons/bi"
import { TbLockOpen } from "react-icons/tb";
// herlpers
import get from 'lodash/get'
import size from 'lodash/size'
import isEmpty from "lodash/isEmpty"
import isUndefined from "lodash/isUndefined"

const getString = (val) => {
  if (size(val) > 0) return val
  return '-'
}

interface UserInterface {
  uuid?: string,
  firstname?: string
  lastname?: string
  email?: string
  phone?: string
  points?: string
}

interface UserCardInterface {
  user: UserInterface
  title: string
}

const UserCard: React.FC<UserCardInterface> = ({ user, title }) => {
  const { t } = useTranslation()

  return (
    <div className="account">
      <h3>{title}</h3>
      <div className="userAttribute">
        <span><FaRegUser color="#0061df" /> {t('USER_NAME')}</span>
        {getString(user?.firstname)}
      </div>
      <div className="userAttribute">
        <span><FaRegUser color="#0061df" /> {"Apellido"}</span>
        {getString(user?.lastname)}
      </div>
      <div className="userAttribute">
        <span><HiOutlineMail color="#0061df" /> {t("USER_EMAIL")}</span>
        {getString(user?.email)}
      </div>
      {!isUndefined(get(user, "phone", undefined)) && <div className="userAttribute">
        <span><HiOutlineDevicePhoneMobile color="#0061df" /> {t("USER_PHONE")}</span>
        {getString(user?.phone)}
      </div>}
      {!isEmpty(user?.points) && <div className="userAttribute">
        <span><BiStats color="#0061df" /> {t("USER_AVAILABLE_POINTS")}</span>
        {getString(user?.points)}
      </div>}
      {!isUndefined(get(user, "roles", undefined)) && <div className="userAttribute">
        <span><TbLockOpen color="#0061df" /> Roles</span>
        {get(user, "roles", []).join(", ")}
      </div>}
    </div>
  )
}

export default UserCard